import { createSlice } from '@reduxjs/toolkit'

const DEFAULT_TIME_WINDOW_DAYS = 7

function getDefaultStartDate() {
  const date = new Date()
  date.setUTCDate(date.getUTCDate() - DEFAULT_TIME_WINDOW_DAYS)
  return date.toISOString()
}

const initialState = {
  sources: [],
  sourcesActiveNames: undefined,
  labResultActiveAnalysisTypeIds: undefined,
  labResultActiveResultTypes: undefined,
  hoveredItem: null,
  hoveredClusterResultKeys: [],
  clickedResultKey: null,
  selectionRange: {
    startDate: getDefaultStartDate(),
    endDate: new Date().toISOString(),
    key: 'selection',
  },
}

const labResults = createSlice({
  name: 'labResults',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setSources: (state, action) => {
      state.sources = action.payload
    },
    setSourceActiveNames: (state, action) => {
      state.sourcesActiveNames = action.payload
    },
    setLabResultTypes: (state, action) => {
      state.labResultTypes = action.payload
    },
    setLabResultActiveAnalysisTypeIds: (state, action) => {
      state.labResultActiveAnalysisTypeIds = action.payload
    },
    setLabResultActiveResultTypes: (state, action) => {
      state.labResultActiveResultTypes = action.payload
    },
    setHoveredItem: (state, action) => {
      state.hoveredItem = action.payload
    },
    setHoveredClusterResultKeys: (state, action) => {
      state.hoveredClusterResultKeys = action.payload
    },
    setClickedResultKey: (state, action) => {
      state.clickedResultKey = action.payload
    },
    setSelectionRange: (state, action) => {
      state.selectionRange = action.payload
    },
  },
})

export const {
  setActiveTab,
  setSources,
  setSourceActiveNames,
  setLabResultTypes,
  setLabResultActiveAnalysisTypeIds,
  setLabResultActiveResultTypes,
  setHoveredItem,
  setHoveredClusterResultKeys,
  setClickedResultKey,
  setSelectionRange,
} = labResults.actions

export function getLabResultHoverKey(result) {
  const properties = result?.properties || {}
  const coordinates = result?.geometry?.coordinates || []

  return result?.id
    || `${properties.source || ''}-${properties.nice_name || ''}-${properties.record_time || ''}-${coordinates.join(',')}`
}

export function getLabResultAnalysisType(analysis) {
  return (analysis.result || analysis.status)?.toLowerCase()
}

export function getVisibleLabResultAnalysis(analysis, activeAnalysisTypeIds, activeResultTypes) {
  return analysis.filter((item) => {
    const matchesAnalysisType = activeAnalysisTypeIds === undefined
      || activeAnalysisTypeIds.includes(item.name || item.type)
    const matchesResultType = activeResultTypes === undefined
      || activeResultTypes.includes(getLabResultAnalysisType(item))

    return matchesAnalysisType && matchesResultType
  })
}

export default labResults.reducer
